export default "__VITE_ASSET__2xBhAr7x__"